import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaLock } from "react-icons/fa";
import { HiMiniWifi } from "react-icons/hi2";
import { IoSettingsSharp } from "react-icons/io5";

import Stat from "../../components/Stat";

export default function DroneWifiStat({ network, forAdmin, onClick, offline }) {
    const [hovered, setHovered] = React.useState(false);
    const [locked, setLocked] = React.useState(false);

    const renderCardTooltip = forAdmin ? (
        <Tooltip id="card-tooltip">
            {locked && (
                <>
                    <FaLock />
                    <br />
                </>
            )}
            {`MAC: ${network?.mac ?? "unknown"}`}
            <br />
            {`IP: ${network?.ip ?? "unknown"}`}
            <br />
        </Tooltip>
    ) : (
        <span></span>
    );

    return (
        <OverlayTrigger
            delay={{ show: 250, hide: 100 }}
            overlay={renderCardTooltip}
            show={hovered || locked}
            popperConfig={{
                modifiers: [{ name: "offset", options: { offset: [0, 10] } }],
            }}
        >
            <div
                {...(forAdmin && {
                    role: "button",
                    tabIndex: 0,
                    onMouseEnter: () => setHovered(true),
                    onMouseLeave: () => setHovered(false),
                    onClick: (e) => {
                        e.stopPropagation();
                        setLocked((v) => !v);
                    },
                    onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setLocked((v) => !v);
                        }
                    },
                })}
            >
                <Stat
                    label="Wi-Fi network"
                    text={
                        <span
                            className={
                                offline ? "text-secondary" : "text-success"
                            }
                        >
                            {network?.ssid ?? "unknown"}
                        </span>
                    }
                    icon={
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <HiMiniWifi
                                className={`${offline ? "text-secondary" : "text-success"} me-2 `}
                            />

                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClick(e);
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation();
                                }}
                                variant="outline-secondary"
                                className="d-flex align-items-center justify-content-center p-0"
                                style={{ width: "30px", height: "30px" }}
                            >
                                <IoSettingsSharp size={22} />
                            </Button>
                        </div>
                    }
                />
            </div>
        </OverlayTrigger>
    );
}
